(function () {
  function forceBold(el) {
    el.style.setProperty("font-weight", "800", "important");
  }

  function apply() {
    const buttons = [...document.querySelectorAll("button, a")]
      .filter(el =>
        (el.textContent || "")
          .replace(/\s+/g, " ")
          .trim()
          .toLowerCase()
          .includes("add to wishlist")
      );

    buttons.forEach(btn => {
      // Force immediately
      forceBold(btn);

      // Force again on hover
      btn.addEventListener("mouseenter", () => forceBold(btn));
      btn.addEventListener("mouseover", () => forceBold(btn));
      btn.addEventListener("focus", () => forceBold(btn));
    });
  }

  // Run repeatedly to beat app hover resets
  let runs = 0;
  const interval = setInterval(() => {
    apply();
    runs++;
    if (runs > 50) clearInterval(interval); // ~10 seconds
  }, 200);

  document.addEventListener("DOMContentLoaded", apply);
  window.addEventListener("load", apply);

  new MutationObserver(apply).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

